// extracted by mini-css-extract-plugin
module.exports = {"inlineParam":"_93444fe79c--inlineParam--Q4WY4"};